import {LOGIN, USERS, DASHBOARD,POSTS,USERS_GROUPS, 
    GROUPS_PERMISSIONS, CHAT,USERS_PERMISSIONS,FAILED_URLS, SETTINGS,
    CAMPAIGNS,NOTIFICATIONS,DIRECT_MESSAGE, SIGNUP_CODE
} from "../lib/constants/actions";
import { takeLatest } from 'redux-saga/effects';
import * as login from './login.saga';
import * as user from './users.saga';
import * as dashboard from './dashboard.saga';
import * as post from './post.saga';
import * as groups from './usersGroups.saga';
import * as groupsPermissions from './usersGroupsPermissions.saga';
import * as chat from './chat.saga';
import * as failedUrls from './failedUrls.saga';
import * as setting from './setting.saga';
import * as campaign from './campaign.saga';
import * as notifications from './notifications.saga';
import * as directMessage from './directMessage.saga';
import * as signupCodes from './signupCodes.saga';


export default function* rootSaga() {


    yield takeLatest(SIGNUP_CODE.GET_SIGNUP_CODES,  signupCodes.getCodes);
    yield takeLatest(SIGNUP_CODE.SAVE_SIGNUP_CODE,  signupCodes.saveCode);
    yield takeLatest(SIGNUP_CODE.DELETE_SIGNUP_CODE,  signupCodes.deleteCode);



    yield takeLatest(DIRECT_MESSAGE.SEND_DIRECT_MESSAGE,  directMessage.sendDirectMessages);
    yield takeLatest(DIRECT_MESSAGE.FETCH_DIRECT_MESSAGE,  directMessage.getMessages);

    // Campaign actions
    yield takeLatest(NOTIFICATIONS.SEND_NOTIFICATION,  notifications.sendNotification);

    // Campaign actions
    yield takeLatest(CAMPAIGNS.GET_CAMPAIGNS,  campaign.getCampaigns);
    yield takeLatest(CAMPAIGNS.GET_CAMPAIGNS_DATA,  campaign.getCampaignDetails);
    yield takeLatest(CAMPAIGNS.CHANGE_STATUS,  campaign.changeStatus);
    yield takeLatest(CAMPAIGNS.GET_CAMPAIGN_CHARGES,  campaign.getCharges);
    yield takeLatest(CAMPAIGNS.SAVE_CAMPAIGN_CHARGES,  campaign.saveCharges);
    yield takeLatest(CAMPAIGNS.GET_INTEREST,  campaign.getInterest);
    yield takeLatest(CAMPAIGNS.SAVE_INTEREST,  campaign.saveInterest);
    yield takeLatest(CAMPAIGNS.DELETE_INTEREST,  campaign.deleteInterest);
    yield takeLatest(CAMPAIGNS.GET_TRANSACTION_HISTORY,  campaign.getTransactionHistory);
    yield takeLatest(CAMPAIGNS.GET_CAMPAIGN_USER,  campaign.getCampaignUsers);
    yield takeLatest(CAMPAIGNS.APPROVE_CAMPAIGN,  campaign.approveCampaign);

    yield takeLatest(CAMPAIGNS.SAVE_CAMPAIGN_SETTING,  campaign.saveCampaignSetting);
    yield takeLatest(CAMPAIGNS.GET_CAMPAIGN_SETTING,  campaign.getCampaignSetting);
    yield takeLatest(CAMPAIGNS.DELETE_CAMPAIGN_SETTING,  campaign.deleteCampaignSetting);
    yield takeLatest(CAMPAIGNS.GET_CAMPAIGN_INSIGHT,  campaign.getCampaignInsight);

    //setting actions
    yield takeLatest(SETTINGS.GET_SETTING,  setting.getSetting);
    yield takeLatest(SETTINGS.SAVE_SETTING,  setting.saveSetting);
    yield takeLatest(SETTINGS.GET_APP_VERSION_SETTING,  setting.getAppVersion);
    yield takeLatest(SETTINGS.SAVE_APP_VERSION_SETTING,  setting.saveAppVersion);


    //chat actions
    yield takeLatest(CHAT.GET_ROOMS,  chat.getRooms);
    yield takeLatest(CHAT.GET_MESSAGES,  chat.getMessages);
    yield takeLatest(CHAT.ACCESS_REQUEST,  chat.sendAccessRequest);


    //login actions
    yield takeLatest(LOGIN.TRY_LOGIN,  login.tryLogin);
    yield takeLatest(LOGIN.GET_LOGIN_DATA,  login.getLoginData);
    yield takeLatest(LOGIN.CHANGE_PASSWORD,  login.changePassword);
    yield takeLatest(LOGIN.RESET_PASSWORD,  login.resetPassword);
    yield takeLatest(LOGIN.VERIFY_OTP,  login.verifyOtp);

    // user actions
    yield takeLatest(USERS.GET_USERS,  user.getUsersList);
    yield takeLatest(USERS.GET_REPORT_USERS,  user.getReportUsers);
    
    yield takeLatest(USERS.GET_ADMIN_USERS,  user.getAdminUsers);
    yield takeLatest(USERS.GET_USER_PROFILE,  user.getUserProfile);
    yield takeLatest(USERS.SUSPEND_ACCOUNT,  user.suspendAccount);
    yield takeLatest(USERS.UPDATE_PROFILE,  user.updateProfile);
    yield takeLatest(USERS.ADD_USER,  user.addUser);
    yield takeLatest(USERS.GET_USERS_LOCATIONS,  user.getUsersLocations);

    yield takeLatest(USERS.GET_FOLLOWERS,  user.getFollowers);
    yield takeLatest(USERS.GET_FOLLOWING,  user.getFollowing);
    yield takeLatest(USERS.GET_DELETED_USERS,  user.getDeletedUsersList);
    yield takeLatest(USERS.CHANGE_APP_PASSWORD,  user.changeAppPassword);
    yield takeLatest(USERS.UPDATE_AUTO_FOLLOW,  user.updateAutoFollow);
    yield takeLatest(USERS.CHANGE_ADVERTISE_STATUS,  user.changeAdvertiseStatus);

    //Dashboard
    yield takeLatest(DASHBOARD.GET_ANALYTICS,  dashboard.getDashboardAnalytics);
    yield takeLatest(DASHBOARD.GET_GOOGLE_ANALYTICS,  dashboard.getGoogleAnalytics);
    yield takeLatest(DASHBOARD.GET_GOOGLE_ANALYTICS_GRAPH,  dashboard.getGoogleAnalyticsGraph);
    yield takeLatest(DASHBOARD.GET_TOP_SEARCHES,  dashboard.getTopSearches);
    yield takeLatest(DASHBOARD.GET_CAMPAIGNS_ANALYTICS,  dashboard.getCampaignAnalytics);
    yield takeLatest(DASHBOARD.GET_TRANSACTIONS_GRAPH_DATA,  dashboard.getTransactionsGraphData);
    yield takeLatest(DASHBOARD.GET_ACTIVE_CAMPAIGNS_MAP_DATA,  dashboard.getActiveCampaignMapData);
    yield takeLatest(DASHBOARD.GET_FAILED_URLS_DATA,  dashboard.getFailedUrlsData);
    yield takeLatest(DASHBOARD.SAVE_DASHBOARD_WIDGET,  dashboard.saveDashboardWidget);
    yield takeLatest(DASHBOARD.GET_DASHBOARD_WIDGET,  dashboard.getDashboardWidget);

    // post actions
    yield takeLatest(POSTS.GET_REPORTED_POSTS,  post.getReportPosts);
    yield takeLatest(POSTS.GET_SEARCHES,  post.getSearches);
    yield takeLatest(POSTS.GET_FAVOURITES,  post.getFavourites);

    yield takeLatest(POSTS.REPORTED_BY,  post.getReportedBy);
    yield takeLatest(POSTS.VIEWED_BY,  post.getViewedBy);
    yield takeLatest(POSTS.POST_DETAILS,  post.getPostDetails);
    yield takeLatest(POSTS.DELETE_POST,  post.deletePost);

    // users group
    yield takeLatest(USERS_GROUPS.ADD_GROUPS,  groups.addUserGroup);
    yield takeLatest(USERS_GROUPS.LIST_GROUPS,  groups.getUsersGroups);
    yield takeLatest(USERS_GROUPS.GET_GROUPS_ARRAY,  groups.getUsersGroupsArray);
    yield takeLatest(USERS_GROUPS.ASSIGN_USER_GROUPS,  groups.assignUserGroups);

    // group permission
    yield takeLatest(GROUPS_PERMISSIONS.GET_PERMISSIONS,  groupsPermissions.getGroupsPermissions);
    yield takeLatest(GROUPS_PERMISSIONS.UPDATE_PERMISSIONS,  groupsPermissions.updateGroupPermission);

    yield takeLatest(USERS_PERMISSIONS.GET_USER_PERMISSIONS,  groupsPermissions.getUserPermissions);
    yield takeLatest(USERS_PERMISSIONS.UPDATE_USER_PERMISSIONS,  groupsPermissions.updateUserPermission);

    // Failed Urls
    yield takeLatest(FAILED_URLS.GET_FAILED_URLS,  failedUrls.getFailedUrls);
    yield takeLatest(FAILED_URLS.GET_FAILED_URLS_FREQUENCY,  failedUrls.getFailedUrlsFrequency);
}